
import { Component, Vue,Prop,Watch } from 'vue-property-decorator'
import moment, { Moment } from 'moment'
import conicMask from './circlePress.vue'
import {DailyAttendanceInspectionReportItem} from "@/api/service-proxies";
@Component({
    components: {
        conicMask
    }
})
export default class detailsNav extends Vue {
    @Prop({ type: Object,  }) analysisList!: object; // 接收父级传的值
    @Watch("analysisList") // 更新接收的值  ，不然只会显示第一次接收到的值
    watchAnalysisList(newVal: object) {
        this.analysisList = newVal; // 社团课程新动态数

    }

    config = {
        borderWidth: "3px",
        circleSize: "10px",
        circleColor: "#e4573978",
        borderColor: "#d5f4ee",
        startColor: "#eead99",
        endColor: "#e45739",
        borderBackground: "#d6e4f159",
        centerCircleBg: "#fff",
        clockwise: true,
        showEyes: true,
        eyesSize: "5px", // 结尾处小眼睛大小
    }
    configtwo = {
        borderWidth: "3px",
        circleSize: "10px",
        circleColor: "#11b95c9e",
        borderColor: "#d5f4ee",
        startColor: "#dbf5d5",
        endColor: "#50eb6a",
        borderBackground: "#d6e4f159",
        centerCircleBg: "#fff",
        clockwise: true,
        showEyes: true,
        eyesSize: "5px", // 结尾处小眼睛大小
    }
    configthree = {
        borderWidth: "3px",
        circleSize: "10px",
        circleColor: "#1682e6ba",
        borderColor: "#d5f4ee",
        startColor: "#a8cae9",
        endColor: "#1682e6",
        borderBackground: "#d6e4f159",
        centerCircleBg: "#fff",
        clockwise: true,
        showEyes: true,
        eyesSize: "5px", // 结尾处小眼睛大小
    }
    configFour = {
        borderWidth: "3px",
        circleSize: "10px",
        circleColor: "#ffffff38",
        borderColor: "#d5f4ee",
        startColor: "#f5f7fa03",
        endColor: "#fff",
        borderBackground: "#d6e4f159",
        centerCircleBg: "#fff",
        clockwise: true,
        showEyes: true,
        eyesSize: "5px", // 结尾处小眼睛大小
    }
}
